import { uuid } from "../utils/uuid";
import { PropertySet, defaultPropertyDescriptor } from "../core/Workbook";

export function addNewDescriptorForColumnName(
  properties: PropertySet,
  newName: string
) {
  const propertyKey = uuid();
  properties.nameToKey[newName] = propertyKey;
  properties.keyToName[propertyKey] = newName;
  properties.descriptors[propertyKey] = defaultPropertyDescriptor();
  return propertyKey;
}
